<template>
  <div>
    <b-nav-item-dropdown right>
        <template slot="button-content">
            {{$root.$data.authenticatedUser.username ? $root.$data.authenticatedUser.username : 'Not Logged In'}}
        </template>
        <b-dropdown-item to="/login" v-if="!$root.$data.authenticatedUser.username">Log In</b-dropdown-item>
        <b-dropdown-item to="/logout" v-if="$root.$data.authenticatedUser.username">Log Out</b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
export default {
  name: 'AuthDropdown',
  props: {
  },
}
</script>